// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3651":"3ad39568","4448":"46faeefb","5480":"c8112ea0"}[chunkId] + ".chunk.css";
};